import type { ScrollEffectSettings } from './index';

export type ScrollEffectMode = 'parallax' | 'fixed';

/** `EScrollEffect.PARALLAX` / `.FIXED` — CSS-less literals on the host enum. */
const MODES: readonly ScrollEffectMode[] = ['parallax', 'fixed'];

/**
 * Which scroll effect the layer is under. A **mode**, not a value: the effect
 * moves the layer's geometry and forces four coupled properties, so hosts bind
 * it as a gating class rather than as variables.
 */
export function scrollEffectMode(
    scrollEffect: Pick<ScrollEffectSettings, 'isEnabled' | 'value'> | undefined
): ScrollEffectMode | null {
    if (!scrollEffect?.isEnabled) {
        return null;
    }

    return MODES.find((mode) => mode === scrollEffect.value) ?? null;
}
